import styled from "styled-components";
import { MD_SCREEN } from "../util/screen-size";

export const getStyledDealsWrapper = () => styled.div`
    display: flex;
    
    @media (max-width: ${MD_SCREEN}px) {
        margin-top: 10vh;
        padding: 0 10vw;
        flex-direction: column;
        align-items: center;
        row-gap: 8vh;
    }

    @media (min-width: ${MD_SCREEN}px) {
        justify-content: space-between;
        margin: 12vh 0;
    }

    .title{
        font-family: 'Playfair Display', serif;
        font-size: 4em;
    }

    .description{
        font-size: 1.8em;
        font-weight: 300;
        color: #5F5F64;
    }
`

export const getStyledDealsCard = () => styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: ${MD_SCREEN}px) {
        row-gap: 1vh;
        width: 15vw;
    }

    @media (max-width: ${MD_SCREEN}px) {
        align-items: center;
        padding: 4vh 5vw;
        border: solid 1px rgba(0, 0, 0, .1);
        border-radius: 10px;
    }

    .card-title{
        font-size: 3em;
        font-weight: 600;
        margin-top: 1vh;
        color: #3D3D3F;
        
        @media (min-width: ${MD_SCREEN}px) {
            font-size: 2em;
        }
    }

    .card-description{
        font-size: 1.5em;
        font-weight: 300;
        color: #5F5F64;
    }

    img{
        @media (min-width: ${MD_SCREEN}px) {
            height: 35px;
            width: 35px;
        }
    }
`